import React from "react";
import BiddingIcon from "assets/icons/bidding/biddingTab.png";
import BiddingInteractiveIcon from "assets/icons/bidding/biddingInteractiveTab.png";
import BiddingPlayIcon from "assets/icons/courses/bidPlay.png";
import "./styles.scss";

interface Props {
  onSelect?: (type: "bidding" | "bidding_interactive" | "bid_play") => void;
  activeTab?: string;
  isMobile?: boolean;
}

const TabMixCourses = ({ onSelect, activeTab, isMobile }: Props) => {
  return (
    <div className="custom-tab-bidding-wrapper">
      <div className="custom-tab-bidding-container">
        <div
          className={`wrapper-custom-tab-bidding-item wrapper-custom-tab-bidding-item-right ${
            activeTab === "bidding" ? "wrapper-custom-tab-bidding-item-active" : ""
          }`}>
          <div
            className={"custom-tab-bidding-item custom-tab-bidding-item-right"}
            onClick={() => {
              onSelect("bidding");
            }}>
            <span>בסיס</span>
            <img src={BiddingIcon} alt="Bidding" />
          </div>
        </div>
        <div
          className={`wrapper-custom-tab-bidding-item ${
            activeTab === "bidding_interactive" ? "wrapper-custom-tab-bidding-item-active" : ""
          }`}>
          <div
            className={"custom-tab-bidding-item"}
            onClick={() => {
              onSelect("bidding_interactive");
            }}>
            <span>אינטראקטיבי</span>
            <img src={BiddingInteractiveIcon} alt="Interactive Bidding" />
          </div>
        </div>
        <div
          className={`wrapper-custom-tab-bidding-item wrapper-custom-tab-bidding-item-left ${
            activeTab === "bid_play" ? "wrapper-custom-tab-bidding-item-active" : ""
          }`}>
          <div
            className={"custom-tab-bidding-item custom-tab-bidding-item-left"}
            onClick={() => {
              onSelect("bid_play");
            }}>
            <span>{isMobile ? "B&P" : "Bid & Play"}</span>
            <img src={BiddingPlayIcon} alt="Bid & Play" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabMixCourses;
